module.exports = __webpack_public_path__ + "img/number3.bcb55cdb.svg";